//#region IMPORT
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import useDelete from '../../../../hooks/useDeleteN';
import { useSearch1, useDelete1, useDelete2, useSave1, useSave2, useSave3 } from './HAM_BASIC_02_QUERY';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
/** Icons Import */
import HAM_BASIC_02 from './HAM_BASIC_02';
import { setAddButtonErrorTrue } from '../../../../Reducer/StatusFlagsReducer';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import { setFileFields } from '../../../../Reducer/FileFieldReducer';
import { useSave } from '../../../../hooks/useSaveN';
import { HAM_BASIC_02_Schema } from './HAM_BASIC_02_Schema';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import dayjs from 'dayjs';
import useFileUpload from '../../../../hooks/useFileUpload';
import ExcelJS from 'exceljs';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'HazardousMaterials';
// 엑셀 업로드 (MST+DTL 평면 15컬럼 파싱)
const EXCEL_COLUMN_KEYS = [
  'processType',
  'workerName',
  'productName',
  'substanceName',
  'casNo',
  'contentPercent',
  'managementTarget',
  'specialManagement',
  'workEnvMeasurement',
  'specialHealthExam',
  'permissionTarget',
  'firstExamMonths',
  'examCycleMonths',
  'distributionContact',
  'remark',
];

function HAM_BASIC_02F(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { validateSelection } = useCompanyCustDep({ requireCompany: true, requireCust: true });

  const gridRef1 = useRef(); // MST 그리드
  const gridRef2 = useRef(); // DTL 그리드
  const fileInputRef = useRef(null); // 엑셀 업로드용

  // 그리드 데이터
  const [rowData1, setRowData1] = useState([]); // MST 그리드 데이터 (Detail 제외)
  const [rowData2, setRowData2] = useState([]); // DTL 그리드 데이터 (모든 Detail 데이터)
  // MST 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // MST 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // MST 그리드 변경 시 데이터
  const [deletedRowData1, setDeletedRowData1] = useState([]); // MST 그리드 삭제 시 데이터
  const currentRowIndexRef1 = useRef(null); // MST 그리드 클릭 시 인덱스
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);

  // DTL 그리드 데이터
  const [selectedRowData2, setSelectedRowData2] = useState([]); // DTL 그리드 클릭 시 데이터
  const [changedRowData2, setChangedRowData2] = useState([]); // DTL 그리드 변경 시 데이터
  const [deletedRowData2, setDeletedRowData2] = useState([]); // DTL 그리드 삭제 시 데이터
  const [originalRowData2, setOriginalRowData2] = useState([]); // DTL 원본 데이터 (조회 시 저장, 변경되지 않음)

  // 인쇄 데이터
  const [printGridData, setPrintGridData] = useState([]);

  // 경고표지 첨부파일 모달
  const [fileModalToggle, setFileModalToggle] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewFileName, setPreviewFileName] = useState('');
  const fileUploadInputRef = useRef(null);
  const fileRowClickData = useRef(null);
  const fileFieldType = useRef(null); // 'WARNING_LABEL_FILE_NAME'
  const prevFilePathRef = useRef();

  // 물질명 팝업 상태
  const [substanceNamePopupOpen, setSubstanceNamePopupOpen] = useState(false);
  const [substanceNamePopupRowData, setSubstanceNamePopupRowData] =
    useState(null);
  const [substanceNameTags, setSubstanceNameTags] = useState([]);
  //#endregion

  //#region 커스텀훅
  // 파일 업로드용 useFileUpload
  const {
    SaveLogicPreview,
    SaveLogicFile,
    DeleteLogicFile
  } = useFileUpload({
    oldFilePathField: 'warningLabelFilePath',
    newFileNameField: 'warningLabelSaveName',
    getTargetPath: () => `HazardousMaterials/${searchInfo.custCd}/HAM_BASIC_03`,
  });

  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.hbmId,
    getKeyFromResult: (result) => result.hbmId,
  });
  //#endregion

  //#region useEffect
  useEffect(() => {
    if (!props.searchClick2) return;
    ResetLogic1();

    const { custCd } = searchInfo || {};
    if (!custCd) {
      props.setSearchClick2(false);
      return;
    }

    if (!validateSelection()) {
      props.setSearchClick2(false);
      return;
    }

    SearchLogic1();
    props.setSearchClick2(false);
  }, [props.searchClick2]);

  // 버튼 로직
  useEffect(() => {
    if (props.filterClick2) {
      if (!validateSelection()) {
        props.setFilterClick2(false);
        return;
      }

      gridRef1.current.api.setQuickFilter(searchInfo.searchText || '');
      props.setFilterClick2(false);
    }
    if (props.saveClick2) {
      if (!validateSelection()) {
        props.setSaveClick2(false);
        return;
      }

      SaveLogic1();
      props.setSaveClick2(false);
    }
    if (props.printClick2) {
      if (!validateSelection()) {
        props.setPrintClick2(false);
        return;
      }

      PrintLogic1();
      props.setPrintClick2(false);
    }
  }, [props.filterClick2, props.saveClick2, props.printClick2]);
  //#endregion

  //#region 삭제 관련 함수
  // MST 그리드 삭제
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // MarkedForDeletion1 래핑: rowData1도 함께 업데이트하고 삭제 예정 행을 상단으로 이동
  const MarkedForDeletion1 = useCallback(
    (rows) => {
      if (!rows || rows.length === 0) return;

      // useDelete의 MarkedForDeletion 호출
      deleteHandler1.MarkedForDeletion(rows);

      // rowData1도 업데이트하여 deleteYn 속성 추가하고 삭제 예정 행을 상단으로 이동
      setRowData1((prev = []) => {
        // 모든 행에 deleteYn 속성 업데이트 (기존 삭제 예정 행도 유지)
        const updatedRows = prev.map((row) => {
          const markedRow = rows.find((r) => r.no === row.no);
          if (markedRow) {
            return {
              ...row,
              deleteYn: 'Y',
            };
          }
          // 이미 삭제 예정 행이었던 경우 유지
          return row;
        });

        // 삭제 예정 행과 일반 행 분리
        // rows 배열의 순서를 유지하여 역순으로 처리 (나중에 선택한 것이 위로)
        const newlyDeletedRows = rows
          .map((markedRow) => {
            const foundRow = updatedRows.find((row) => row.no === markedRow.no);
            return foundRow;
          })
          .filter((row) => row && row.deleteYn === 'Y');

        // 이미 삭제 예정 행이었던 행들 (새로 선택되지 않은 삭제 예정 행)
        const existingDeletedRows = updatedRows.filter(
          (row) => row.deleteYn === 'Y' && !rows.some((r) => r.no === row.no)
        );

        const normalRows = updatedRows.filter((row) => row.deleteYn !== 'Y');

        // 새로 선택된 삭제 예정 행을 역순으로 정렬하여 상단으로 이동 (나중에 선택한 것이 위로)
        const reversedNewlyDeletedRows = [...newlyDeletedRows].reverse();

        // 삭제 예정 행을 상단으로 이동 (새로 선택된 행이 가장 위, 그 다음 기존 삭제 예정 행)
        return [
          ...reversedNewlyDeletedRows,
          ...existingDeletedRows,
          ...normalRows,
        ];
      });
    },
    [deleteHandler1]
  );

  // DeleteNewRow 래핑: rowData1도 함께 업데이트
  const DeleteNewRow1 = useCallback(
    (row) => {
      deleteHandler1.DeleteNewRow(row);
      // rowData1에서도 제거
      setRowData1((prev) => prev.filter((r) => r.no !== row.no));
    },
    [deleteHandler1]
  );

  // DTL 그리드 삭제
  const delete2 = useDelete2();
  const deleteHandler2 = useDelete({
    gridRef: gridRef2,
    deleteMutation: delete2,
    updateDeleted: setDeletedRowData2,
    updateRowData: setRowData2,
    deletedRowData: deletedRowData2,
    rowData: rowData2,
    setChangedRowData: setChangedRowData2,
  });
  //#endregion

  //#region 조회 관련 함수
  // 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      // Master 데이터 추출 (중복 제거)
      const masterDataMap = new Map();
      const detailDataList = [];
      setPrintGridData(Commons.InsertNumber(rows));
      rows.forEach((item) => {
        if (!item.hbmId) return;

        // Master 데이터가 아직 없는 경우 추가
        if (!masterDataMap.has(item.hbmId)) {
          const masterData = {
            hbmId: item.hbmId,
            processType: item.processType,
            workerName: item.workerName,
            productName: item.productName,
            firstExamMonths: item.firstExamMonths,
            examCycleMonths: item.examCycleMonths,
            distributionContact: item.distributionContact,
            warningLabelFileName: item.warningLabelFileName,
            warningLabelFilePath: item.warningLabelFilePath,
            remark: item.remark,
          };
          masterDataMap.set(item.hbmId, masterData);
        }

        // Detail 데이터 추출 (hbdId가 있는 경우)
        if (item.hbdId) {
          const detailData = {
            hbdId: item.hbdId,
            hbmId: item.hbmId,
            substanceName: item.substanceName || '',
            casNo: item.casNo,
            contentPercent: item.contentPercent,
            managementTarget: item.managementTarget || 'N',
            specialManagement: item.specialManagement || 'N',
            workEnvMeasurement: item.workEnvMeasurement || 'N',
            specialHealthExam: item.specialHealthExam || 'N',
            permissionTarget: item.permissionTarget || 'N',
          };
          detailDataList.push(detailData);
        }
      });

      // Master 데이터 번호 추가 및 설정
      const masterArray = Array.from(masterDataMap.values());
      const numberedMasterData = Commons.InsertNumber(masterArray);
      setRowData1(numberedMasterData || []);

      // Detail 데이터 번호 추가 및 설정 (각 마스터별로 1부터 시작)
      const numberedDetailData = [];
      // hbmId별로 그룹화
      const detailDataByHbmId = {};
      detailDataList.forEach((detail) => {
        const hbmId = detail.hbmId;
        if (!detailDataByHbmId[hbmId]) {
          detailDataByHbmId[hbmId] = [];
        }
        detailDataByHbmId[hbmId].push(detail);
      });
      // 각 마스터별로 1부터 시작하는 번호 부여
      Object.keys(detailDataByHbmId).forEach((hbmId) => {
        const details = detailDataByHbmId[hbmId];
        details.forEach((detail, index) => {
          numberedDetailData.push({
            ...detail,
            no: index + 1,
          });
        });
      });
      setRowData2(numberedDetailData || []);
      // 원본 데이터 저장 (깊은 복사)
      setOriginalRowData2(
        JSON.parse(JSON.stringify(numberedDetailData || []))
      );
      console.log('numberedDetailData', numberedDetailData);
    },
  });

  const ResetLogic1 = () => {
    // Master 그리드 초기화
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    // Detail 그리드 초기화
    setRowData2([]);
    setOriginalRowData2([]);
    setSelectedRowData2([]);
    setChangedRowData2([]);
    setDeletedRowData2([]);
    gridRef1?.current?.api?.deselectAll();
  };

  const SearchLogic1 = async () => {
    ResetLogic1();
    if (!validateSelection()) return;
    await Search1();
  };
  //#endregion

  //#region 저장 관련 함수
  // 저장
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '제품명, 취급공종, 특수건강진단 주기 (개월), 배포처/연락처, 경고표지 첨부',
    schema: { fields: HAM_BASIC_02_Schema.fields.master },
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: async (rows) => {
      // 1. Master 저장
      const masterResult = await Save1Async(rows);
      const masterData = masterResult?.data || [];

      // 저장 성공 시 반환된 hbmId를 그리드에 반영
      if (masterData && masterData.length > 0) {
        const api = gridRef1.current?.api;
        if (api) {
          rows.forEach((row, index) => {
            const returnedData = masterData[index];
            if (returnedData && returnedData.hbmId) {
              api.forEachNode((node) => {
                if (node.data && node.data.no === row.no) {
                  const updatedData = {
                    ...node.data,
                    hbmId: returnedData.hbmId,
                  };
                  node.setData(updatedData);
                }
              });
            }
          });
        }
      }

      return masterResult;
    },
    fileDelete: async (deletedRows) => {
      // 삭제된 행들에 대해 파일 삭제 처리
      for (const item of deletedRows) {
        if (item.warningLabelFilePath) {
          await DeleteLogicFile(item.warningLabelFilePath);
        }
      }
    },
    fileSave: async (changedRows) => {
      // 저장된 행들에 대해 파일 저장 처리
      for (const item of changedRows) {
        // 파일이 삭제된 경우 (파일명이 빈 문자열이고 기존 파일 경로가 있는 경우)
        if (!item.warningLabelFileName && item.warningLabelFilePath) {
          // 저장소에서 기존 파일 삭제
          await DeleteLogicFile(item.warningLabelFilePath);
        }
        // 새 파일이 업로드된 경우
        else if (item.previewFilePath) {
          await SaveLogicFile(item, searchInfo.custCd);
        }
      }
    },
    onSuccessRefresh: () => SearchLogic1(),
    partialRefresh: async ({ saveResult, changedRows }) => {
      await handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: SearchLogic1,
      });
    },
  });

  // Detail 저장을 위한 별도 useSave
  const { run: Save2 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '물질명, CAS NO.',
    schema: { fields: HAM_BASIC_02_Schema.fields.detail },
    getChangedRows: () => changedRowData2.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRowData2,
    requestDelete: deleteHandler2.DeleteLogic,
    requestSave: async (rows) => {
      return await Save2Async(rows);
    },
    onSuccessRefresh: () => SearchLogic1(),
  });

  //저장버튼 클릭 시 함수
  const SaveLogic1 = async () => {
    // Master와 Detail 변경사항 확인
    const masterHasDelete = deletedRowData1.length > 0;
    const masterChangedRows = changedRowData1.filter((row) => !row.deleteYn);
    const masterHasChange = masterChangedRows.length > 0;

    const detailHasDelete = deletedRowData2.length > 0;
    const detailChangedRows = changedRowData2.filter((row) => !row.deleteYn);
    const detailHasChange = detailChangedRows.length > 0;

    if (
      !masterHasDelete &&
      !masterHasChange &&
      !detailHasDelete &&
      !detailHasChange
    ) {
      dispatch(setAddButtonErrorTrue());
      dispatch(
        showSnackbar({
          message: '저장할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    // Master 저장 먼저 실행
    if (masterHasDelete || masterHasChange) {
      await Save1();
    }

    // Detail 저장 실행
    if (detailHasDelete || detailHasChange) {
      await Save2();
    }
  };
  //#endregion

  //#region 그리드 관련 함수
  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  // + 내역 추가 버튼 클릭 핸들러
  const handleAddSubItem = (masterRow) => {
    if (!masterRow || !gridRef1.current) return;

    const api = gridRef1.current.api;
    let targetMasterNode = null;

    // Master 행 찾기
    api.forEachNode((node) => {
      if (node.data && node.data.no === masterRow.no) {
        targetMasterNode = node;
      }
    });

    if (!targetMasterNode) return;

    // 새 Detail 행 생성
    const newDetailRow = {
      no: Date.now(),
      hbmId: masterRow.hbmId || '',
      hbdId: null,
      substanceName: '',
      casNo: '',
      contentPercent: null,
      managementTarget: 'N',
      specialManagement: 'N',
      workEnvMeasurement: 'N',
      specialHealthExam: 'N',
      permissionTarget: 'N',
      newYn: 'Y',
    };

    // Master의 detailData에 새 행 추가
    const currentMasterData = { ...targetMasterNode.data };
    if (!currentMasterData.detailData) {
      currentMasterData.detailData = [];
    }

    // 번호 추가
    const numberedDetailData = Commons.InsertNumber([
      ...currentMasterData.detailData,
      newDetailRow,
    ]);
    currentMasterData.detailData = numberedDetailData;

    // Master 행 데이터 업데이트 (detailData만 업데이트)
    targetMasterNode.setData(currentMasterData);

    // 번호가 추가된 최종 Detail 행 찾기 (마지막에 추가된 행)
    const finalDetailRow = numberedDetailData[numberedDetailData.length - 1];

    // rowData1 state 업데이트 (중요: 상태 동기화)
    setRowData1((prev) =>
      prev.map((row) =>
        row.no === currentMasterData.no ? currentMasterData : row
      )
    );

    // changedRowData2에 새 Detail 행 추가 (번호가 추가된 최종 데이터 사용)
    setChangedRowData2((prev) => {
      const filtered = prev.filter((item) => item.no !== finalDetailRow.no);
      return [...filtered, finalDetailRow];
    });
  };
  //#endregion

  //#region 파일 관련 함수
  // 경고표지 - 업로드 버튼 클릭 이벤트
  const PopupClickEvent1 = async (rowData) => {
    const fileName = rowData.warningLabelFileName || '';
    const filePath = rowData.warningLabelFilePath || '';
    const previewPath = rowData.previewFilePath || '';

    let previewUrl = '';
    if (previewPath) {
      const fixedPath = Commons.EncodeUrl(previewPath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    } else if (filePath) {
      const fixedPath = Commons.EncodeUrl(filePath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    }

    dispatch(setFileFields({
      previewFileName: fileName || '파일 선택',
      previewUrl,
    }));

    setTimeout(() => setFileModalToggle(true), 100);
  };

  const handleFileDelete = async () => {
    const oldFilePath = prevFilePathRef.current || '';
    await moveAndReplaceFile(oldFilePath, null, null, null);

    setPreviewFileName('');
    setPreviewUrl('');
    prevFilePathRef.current = '';

    // 그리드에서도 파일 정보 제거
    const api = props.gridRef1.current?.api;
    const clickedRowData = fileRowClickData.current;
    if (api && clickedRowData) {
      let targetRowNode = null;
      api.forEachNode((node) => {
        if (node.data === clickedRowData) {
          targetRowNode = node;
        }
      });

      if (targetRowNode && fileFieldType.current) {
        // warningLabelFileName과 warningLabelFilePath를 빈 문자열로 설정
        // warningLabelFileName은 컬럼이 정의되어 있으므로 setDataValue 사용
        targetRowNode.setDataValue('warningLabelFileName', '');
        // warningLabelFilePath는 컬럼이 정의되어 있지 않으므로 setData만 사용
        targetRowNode.setData({
          ...targetRowNode.data,
          warningLabelFileName: '',
          warningLabelFilePath: '',
          editYn: 'Y',
        });
        setChangedRowData1((prev) => {
          const filtered = prev.filter((row) => row.no !== clickedRowData.no);
          return [
            ...filtered,
            {
              ...clickedRowData,
              warningLabelFileName: '',
              warningLabelFilePath: '',
              editYn: 'Y',
            },
          ];
        });
      }
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.name.length > 100) {
      dispatch(
        showSnackbar({
          message:
            '파일명 길이가 100자를 초과합니다. 100자 이하로 파일명을 수정해 주세요.',
          type: 'warning',
        })
      );
      return;
    }

    const api = gridRef1.current?.api;
    const clickedRowData = fileRowClickData.current;
    const fieldType = fileFieldType.current;

    if (!api || !clickedRowData || !fieldType) {
      dispatch(
        showSnackbar({
          message: '파일 정보가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      const fileName = file.name;

      // 파일 경로 설정
      const baseFilePath = `HazardousMaterials/${searchInfo.custCd}/HAM_BASIC_03`;
      const filePath = baseFilePath;

      // 기존 파일 삭제 (있는 경우)
      const oldFilePath = clickedRowData.warningLabelFilePath || '';

      if (oldFilePath) {
        await moveAndReplaceFile(oldFilePath, null, null, null);
      }

      // 파일 업로드
      const formData = new FormData();
      formData.append('UserId', userInfo.userid);
      formData.append('FilePath', filePath);
      formData.append('FormFile', file);

      const res = await Commons.Axios(
        'file2',
        Global.file.useUrl + Global.urls.Execute.videoUpload,
        null,
        formData
      );

      const uploadedFilePath = res?.data?.filePath || '';

      if (!uploadedFilePath) {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패',
            type: 'error',
          })
        );
        return;
      }

      // 경로 정리
      const cleanedPath = uploadedFilePath
        .replace(/^.*\\HazardousMaterials/, 'HazardousMaterials')
        .replace(/\\/g, '/');

      // HWP 파일인 경우 PDF로 변환
      const ext = file.name.split('.').pop()?.toLowerCase();
      let finalPath = cleanedPath;
      let previewPath = cleanedPath;

      if (ext === 'hwp') {
        const hwpPdfUrl = await ConvertHwpToPdf(cleanedPath);
        if (hwpPdfUrl) {
          // HWP 변환된 PDF URL 사용
          previewPath = hwpPdfUrl;
        }
      }

      // 그리드에 파일 정보 저장
      let targetRowNode = null;
      api.forEachNode((node) => {
        // 다른 컬럼 변경 후에는 node.data 참조가 달라질 수 있으므로 no로 비교
        if (node.data?.no === clickedRowData?.no) {
          targetRowNode = node;
        }
      });

      if (targetRowNode) {
        // 업데이트할 데이터 객체 생성
        const updatedData = {
          ...targetRowNode.data,
          warningLabelFileName: fileName,
          warningLabelFilePath: finalPath,
          editYn: 'Y',
        };

        // 컬럼 값 업데이트
        targetRowNode.setDataValue('warningLabelFileName', fileName);
        targetRowNode.setDataValue('warningLabelFilePath', finalPath);
        targetRowNode.setData(updatedData);

        setChangedRowData1((prev) => {
          const filtered = prev.filter((row) => row.no !== clickedRowData.no);
          return [...filtered, updatedData];
        });

        // 파일 경로 업데이트
        prevFilePathRef.current = finalPath;
        setPreviewFileName(fileName);

        // 미리보기용 URL 생성
        if (['png', 'jpg', 'jpeg'].includes(ext)) {
          // 이미지 파일은 data URL로 미리보기
          const reader = new FileReader();
          reader.onload = (event) => {
            setPreviewUrl(event.target.result);
          };
          reader.readAsDataURL(file);
        } else if (ext === 'pdf' || ext === 'hwp') {
          // PDF와 HWP(변환된 PDF)는 서버 경로로 미리보기
          if (ext === 'hwp' && previewPath.startsWith('http')) {
            // HWP 변환된 PDF URL이 전체 URL인 경우
            setPreviewUrl(previewPath);
          } else {
            const fixedPath = fixUrl(previewPath);
            setPreviewUrl(
              fixedPath ? Global.file.useUrl + 'files/' + fixedPath : ''
            );
          }
        } else {
          // 기타 파일도 서버 경로로 미리보기
          const fixedPath = fixUrl(previewPath);
          setPreviewUrl(
            fixedPath ? Global.file.useUrl + 'files/' + fixedPath : ''
          );
        }

        dispatch(
          showSnackbar({
            message: `파일이 업로드되었습니다: ${fileName}`,
            type: 'success',
          })
        );
      }
    } catch (error) {
      console.log(error);
      console.error(error);
      dispatch(
        showSnackbar({
          message: `파일 업로드 실패: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      if (fileUploadInputRef.current) {
        fileUploadInputRef.current.value = '';
      }
    }
  };

  const handleFileClick = () => {
    fileUploadInputRef.current?.click();
  };

  // HWP -> PDF 변환
  const ConvertHwpToPdf = async (_filePath) => {
    if (!_filePath) {
      console.error('ConvertHwpToPdf: filePath가 없습니다.');
      return null;
    }

    try {
      const payload = { FilePath: _filePath };

      const response = await Commons.Axios(
        'post1',
        Global.file.useUrl + Global.urls.Execute.ConvertHwpToPdf,
        payload
      );

      // 서버 응답 검증
      if (response?.data?.url) {
        return response.data.url;
      } else {
        console.error('ConvertHwpToPdf: 서버 응답이 유효하지 않음', response);
        return null;
      }
    } catch (error) {
      console.log(error);
      console.error('ConvertHwpToPdf: 요청 중 오류 발생', error);
      return null;
    }
  };

  // 파일 선택 후 처리
  const moveAndReplaceFile = async (
    _oldFilePath,
    _sourcePreviewPath,
    _newFileName,
    _targetPath
  ) => {
    try {
      const payload = {
        oldFilePath: _oldFilePath, // 기존 파일 경로 (없으면 빈 문자열)
        sourcePreviewPath: _sourcePreviewPath, // Preview 파일 경로
        newFileName: _newFileName, // 최종 저장할 파일명
        targetPath: _targetPath,
      };

      const { data } = await Commons.Axios(
        'post1',
        Global.file.useUrl + Global.urls.Execute.moveAndReplaceFile,
        payload
      );

      if (!data || data.type === 'Error') {
        throw new Error(data?.message || '파일 이동 실패');
      }

      return data; // 성공 시 서버 응답 반환
    } catch (e) {
      console.log(e);
      console.error('파일 선택 후 처리 Error:', e);
      dispatch(
        showSnackbar({
          message: e.message || '파일 저장 실패',
          type: 'error',
        })
      );
      return null;
    }
  };

  const renderPreview = () => {
    if (!previewUrl) return <div>미리보기 영역</div>;

    // data URL인지 확인 (data:로 시작)
    const isDataUrl = previewUrl.startsWith('data:');

    // 확장자 추출
    let ext = '';
    let fullUrl = previewUrl;

    if (isDataUrl) {
      // data URL인 경우 (이미지 파일)
      return (
        <img
          src={previewUrl}
          alt="미리보기"
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      );
    } else {
      // 서버 경로인 경우
      ext = getExtension(previewUrl);
      fullUrl = previewUrl.startsWith('http')
        ? previewUrl
        : Global.file.useUrl + 'files/' + previewUrl;
    }

    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return (
        <img
          src={fullUrl}
          alt="미리보기"
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      );
    }

    if (ext === 'pdf' || ext === 'hwp') {
      // HWP 파일인 경우, 이미 변환된 PDF URL이거나 .hwp를 .pdf로 변경
      // ConvertHwpToPdf가 반환한 URL은 이미 PDF URL이므로 그대로 사용
      let pdfUrl = fullUrl;
      if (ext === 'hwp' && !fullUrl.includes('.pdf')) {
        // HWP 파일이고 PDF URL이 아닌 경우에만 확장자 변경
        pdfUrl = fullUrl.replace(/\.hwp$/i, '.pdf');
      }
      return (
        <iframe
          src={pdfUrl}
          width="100%"
          height="600px"
          title="PDF 미리보기"
          allow="fullscreen"
        />
      );
    }

    if (['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
      const docs = [{ uri: fullUrl, fileType: ext }];
      return (
        <DocViewer
          documents={docs}
          pluginRenderers={DocViewerRenderers}
          style={{ width: '100%', height: '100%' }}
        />
      );
    }

    return <div>지원하지 않는 형식입니다.</div>;
  };

  const handleFileModalSave = async () => {
    // 파일은 이미 선택 시 업로드되었으므로 팝업만 닫기
    setFileModalToggle(false);
  };

  // 다운로드 기능
  const DownloadLogic1 = async () => {
    if (!previewUrl) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const urlParts = previewUrl.split('/');
      const rawFileName = urlParts[urlParts.length - 1];
      const fileName = decodeURIComponent(rawFileName) || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: previewUrl,
      };

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      );

      const contentType = result?.headers?.['content-type'];
      const blobData = result?.data;

      if (!blobData || !contentType) {
        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showSnackbar({
          message: `"${fileName}" 다운로드 완료`,
          type: 'success',
        })
      );
    } catch (error) {
      console.log(error);
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
    }
  };

  //#region 엑셀 업/다운로드
  // 엑셀 업로드  
  // const ExcelUpload1 = async (file) => {
  //   try {
  //     dispatch(showLoading());

  //     const arrayBuffer = await file.arrayBuffer();
  //     const workbook = new ExcelJS.Workbook();
  //     await workbook.xlsx.load(arrayBuffer);

  //     const worksheet = workbook.worksheets[0];
  //     if (!worksheet) {
  //       dispatch(
  //         showSnackbar({
  //           message: '엑셀 시트를 불러오지 못했습니다.',
  //           type: 'warning',
  //         })
  //       );
  //       dispatch(closeLoading());
  //       return;
  //     }

  //     const startRow = 7;
  //     const uploadedFlatRows = [];
  //     let currentRow = startRow;
  //     let hasData = true;

  //     while (hasData) {
  //       const row = worksheet.getRow(currentRow);
  //       const rowData = {};

  //       const firstCellValue = row.getCell(1).value;
  //       if (!firstCellValue || firstCellValue.toString().trim() === '') {
  //         hasData = false;
  //         break;
  //       }

  //       EXCEL_COLUMN_KEYS.forEach((key, index) => {
  //         const cell = row.getCell(index + 1);
  //         let value = cell.value;

  //         if (value === null || value === undefined) {
  //           value = '';
  //         } else {
  //           if (typeof value === 'object' && value !== null) {
  //             value = Array.isArray(value.richText) && value.richText.length > 0
  //               ? value.richText.map((item) => item?.text || '').join('')
  //               : value.toString().trim();
  //           } else {
  //             value = value.toString().trim();
  //           }
  //         }
  //         rowData[key] = value;
  //       });

  //       const ynKeys = ['managementTarget', 'specialManagement', 'workEnvMeasurement', 'specialHealthExam', 'permissionTarget'];
  //       ynKeys.forEach((k) => {
  //         const v = rowData[k];
  //         rowData[k] = v === 'Y' || v === '✓' ? 'Y' : 'N';
  //       });

  //       uploadedFlatRows.push(rowData);
  //       currentRow++;
  //       if (currentRow > startRow + 2000) break;
  //     }

  //     if (uploadedFlatRows.length === 0) {
  //       dispatch(
  //         showSnackbar({
  //           message: '읽을 수 있는 데이터가 없습니다.',
  //           type: 'warning',
  //         })
  //       );
  //       dispatch(closeLoading());
  //       return;
  //     }

  //     // MST 키: 제품명, 취급공종 (HEA_BASIC_02 makeKeyString 구조 적용)
  //     const makeMasterKey = (item) => {
  //       const productName = item.productName != null ? String(item.productName).trim() : '';
  //       const processType = item.processType != null ? String(item.processType).trim() : '';
  //       return `${productName}|${processType}`;
  //     };

  //     // DTL 키: 물질명, CAS NO.
  //     const makeDetailKey = (item) => {
  //       const substanceName = item.substanceName != null ? String(item.substanceName).trim() : '';
  //       const casNo = item.casNo != null ? String(item.casNo).trim() : '';
  //       return `${substanceName}|${casNo}`;
  //     };

  //     const excelGroups = new Map();
  //     uploadedFlatRows.forEach((flatRow) => {
  //       const key = makeMasterKey(flatRow);
  //       if (!key || key === '|') return;
  //       if (!excelGroups.has(key)) excelGroups.set(key, []);
  //       excelGroups.get(key).push(flatRow);
  //     });

  //     const excelMasterKeys = new Set(excelGroups.keys());
  //     const existingMasters = (rowData1 || []).filter((r) => !r.deleteYn);
  //     const existingDetails = (rowData2 || []).filter((r) => !r.deleteYn);

  //     const existingMasterByKey = new Map();
  //     const existingMasterIdToKey = new Map();
  //     existingMasters.forEach((m) => {
  //       const k = makeMasterKey(m);
  //       if (k) {
  //         existingMasterByKey.set(k, m);
  //         const id = m.hbmId ?? m.no;
  //         if (id != null) existingMasterIdToKey.set(String(id), k);
  //       }
  //     });

  //     const masterCompareFields = ['productName', 'processType', 'workerName', 'firstExamMonths', 'examCycleMonths', 'distributionContact', 'remark'];
  //     const hasMasterChanges = (existing, excelFirst) =>
  //       masterCompareFields.some((f) => {
  //         const a = existing[f] != null ? String(existing[f]).trim() : '';
  //         const b = excelFirst[f] != null ? String(excelFirst[f]).trim() : '';
  //         return a !== b;
  //       });

  //     const detailCompareFields = ['substanceName', 'casNo', 'contentPercent', 'managementTarget', 'specialManagement', 'workEnvMeasurement', 'specialHealthExam', 'permissionTarget'];
  //     const hasDetailChanges = (existing, flat) =>
  //       detailCompareFields.some((f) => {
  //         const a = existing[f] != null ? String(existing[f]).trim() : '';
  //         const b = flat[f] != null ? String(flat[f]).trim() : '';
  //         return a !== b;
  //       });

  //     const numericNos = (rowData1 || []).map((row) => Number(row.no)).filter((v) => Number.isFinite(v));
  //     let nextMasterNo = numericNos.length ? Math.max(...numericNos) + 1 : 1;

  //     // ---- MST: HEA_BASIC_02 구조 (updatedRows, newRows, rowsToDelete → updatedRowData → finalRowData) ----
  //     const masterUpdatedRows = [];
  //     const masterNewRows = [];
  //     const masterUpdatedKeys = new Set();

  //     excelGroups.forEach((flatRows, mKey) => {
  //       const first = flatRows[0];
  //       if (existingMasterByKey.has(mKey)) {
  //         const existingRow = existingMasterByKey.get(mKey);
  //         if (hasMasterChanges(existingRow, first)) {
  //           masterUpdatedRows.push({
  //             ...existingRow,
  //             productName: first.productName ?? existingRow.productName,
  //             processType: first.processType ?? existingRow.processType,
  //             workerName: first.workerName ?? existingRow.workerName,
  //             firstExamMonths: first.firstExamMonths ?? existingRow.firstExamMonths,
  //             examCycleMonths: first.examCycleMonths ?? existingRow.examCycleMonths,
  //             distributionContact: first.distributionContact ?? existingRow.distributionContact,
  //             remark: first.remark ?? existingRow.remark,
  //             editYn: 'Y',
  //             no: existingRow.no,
  //             hbmId: existingRow.hbmId ?? existingRow.no,
  //           });
  //           masterUpdatedKeys.add(mKey);
  //         }
  //       } else {
  //         masterNewRows.push({
  //           no: nextMasterNo++,
  //           hbmId: nextMasterNo - 1,
  //           productName: first.productName || '',
  //           processType: first.processType || '',
  //           workerName: first.workerName || '',
  //           firstExamMonths: first.firstExamMonths || '',
  //           examCycleMonths: first.examCycleMonths || '',
  //           distributionContact: first.distributionContact || '',
  //           warningLabelFileName: '',
  //           warningLabelFilePath: '',
  //           remark: first.remark || '',
  //           newYn: 'Y',
  //         });
  //       }
  //     });

  //     const mastersToDelete = [];
  //     rowData1.forEach((row) => {
  //       if (row.deleteYn) return;
  //       const key = makeMasterKey(row);
  //       if (key && key !== '|' && !excelMasterKeys.has(key)) {
  //         mastersToDelete.push({ ...row, deleteYn: 'Y' });
  //       }
  //     });

  //     const masterUpdatedRowData = (rowData1 || []).map((row) => {
  //       if (row.deleteYn) return row;
  //       const key = makeMasterKey(row);
  //       if (key && masterUpdatedKeys.has(key)) {
  //         const updatedRow = masterUpdatedRows.find((ur) => makeMasterKey(ur) === key);
  //         if (updatedRow) return updatedRow;
  //       }
  //       if (mastersToDelete.some((rd) => rd.no === row.no)) {
  //         return { ...row, deleteYn: 'Y' };
  //       }
  //       return row;
  //     });

  //     const finalMasters = [...masterUpdatedRowData, ...masterNewRows];

  //     const masterKeyToNo = new Map();
  //     finalMasters.filter((m) => !m.deleteYn).forEach((m) => {
  //       const k = makeMasterKey(m);
  //       if (k) masterKeyToNo.set(k, m.hbmId ?? m.no);
  //     });
  //     masterNewRows.forEach((m, idx) => {
  //       const k = makeMasterKey(m);
  //       if (k) masterKeyToNo.set(k, m.no);
  //     });

  //     // ---- DTL: HEA_BASIC_02 구조 (MST별 detail updatedRows, newRows, rowsToDelete → updatedRowData → finalRowData) ----
  //     const excelDetailByMasterKey = new Map();
  //     excelGroups.forEach((flatRows, mKey) => {
  //       const detailMap = new Map();
  //       flatRows.forEach((flat) => {
  //         const dKey = makeDetailKey(flat);
  //         if (!detailMap.has(dKey)) detailMap.set(dKey, flat);
  //       });
  //       excelDetailByMasterKey.set(mKey, detailMap);
  //     });

  //     const existingDetailByMasterId = new Map();
  //     existingDetails.forEach((d) => {
  //       const id = d.hbmId ?? d.no;
  //       const key = id != null ? String(id) : '';
  //       if (!existingDetailByMasterId.has(key)) existingDetailByMasterId.set(key, new Map());
  //       const k = makeDetailKey(d);
  //       if (k) existingDetailByMasterId.get(key).set(k, d);
  //     });

  //     const detailsToDelete = [];
  //     const detailUpdatedRows = [];
  //     const detailNewRows = [];
  //     const detailUpdatedKeysByMasterId = new Map();

  //     (rowData2 || []).forEach((d) => {
  //       const masterId = d.hbmId ?? d.no;
  //       const masterKey = masterId != null ? existingMasterIdToKey.get(String(masterId)) : null;
  //       if (!masterKey || !excelMasterKeys.has(masterKey)) {
  //         detailsToDelete.push({ ...d, deleteYn: 'Y' });
  //         return;
  //       }
  //       const excelDetailMap = excelDetailByMasterKey.get(masterKey);
  //       const dKey = makeDetailKey(d);
  //       if (!dKey) return;
  //       if (!excelDetailMap || !excelDetailMap.has(dKey)) {
  //         detailsToDelete.push({ ...d, deleteYn: 'Y' });
  //         return;
  //       }
  //       const flat = excelDetailMap.get(dKey);
  //       if (hasDetailChanges(d, flat)) {
  //         detailUpdatedRows.push({
  //           ...d,
  //           substanceName: flat.substanceName ?? d.substanceName,
  //           casNo: flat.casNo ?? d.casNo,
  //           contentPercent: flat.contentPercent ?? d.contentPercent,
  //           managementTarget: flat.managementTarget ?? d.managementTarget,
  //           specialManagement: flat.specialManagement ?? d.specialManagement,
  //           workEnvMeasurement: flat.workEnvMeasurement ?? d.workEnvMeasurement,
  //           specialHealthExam: flat.specialHealthExam ?? d.specialHealthExam,
  //           permissionTarget: flat.permissionTarget ?? d.permissionTarget,
  //           editYn: 'Y',
  //         });
  //         const key = masterId != null ? String(masterId) : '';
  //         if (!detailUpdatedKeysByMasterId.has(key)) detailUpdatedKeysByMasterId.set(key, new Set());
  //         detailUpdatedKeysByMasterId.get(key).add(dKey);
  //       }
  //     });

  //     excelGroups.forEach((flatRows, mKey) => {
  //       const masterNo = masterKeyToNo.get(mKey);
  //       if (masterNo == null) return;
  //       const existingMap = existingDetailByMasterId.get(String(masterNo)) || new Map();
  //       const flatRowsDedup = new Map();
  //       flatRows.forEach((flat) => {
  //         const dKey = makeDetailKey(flat);
  //         if (!flatRowsDedup.has(dKey)) flatRowsDedup.set(dKey, flat);
  //       });
  //       flatRowsDedup.forEach((flat, dKey) => {
  //         if (existingMap.has(dKey)) return;
  //         let detailNo = (detailNewRows.filter((r) => (r.hbmId ?? r.no) === masterNo).length) + 1;
  //         detailNewRows.push({
  //           no: detailNo,
  //           hbmId: masterNo,
  //           hbdId: null,
  //           substanceName: flat.substanceName || '',
  //           casNo: flat.casNo || '',
  //           contentPercent: flat.contentPercent ?? '',
  //           managementTarget: flat.managementTarget || 'N',
  //           specialManagement: flat.specialManagement || 'N',
  //           workEnvMeasurement: flat.workEnvMeasurement || 'N',
  //           specialHealthExam: flat.specialHealthExam || 'N',
  //           permissionTarget: flat.permissionTarget || 'N',
  //           newYn: 'Y',
  //         });
  //       });
  //     });

  //     const detailUpdatedRowData = (rowData2 || []).map((d) => {
  //       if (d.deleteYn) return d;
  //       const masterId = d.hbmId ?? d.no;
  //       if (detailsToDelete.some((rd) => rd.no === d.no && String(rd.hbmId ?? rd.no) === String(masterId))) {
  //         return { ...d, deleteYn: 'Y' };
  //       }
  //       const key = masterId != null ? String(masterId) : '';
  //       const updatedSet = detailUpdatedKeysByMasterId.get(key);
  //       const dKey = makeDetailKey(d);
  //       if (updatedSet && updatedSet.has(dKey)) {
  //         const updatedRow = detailUpdatedRows.find((ur) => (ur.hbmId ?? ur.no) === masterId && makeDetailKey(ur) === dKey);
  //         if (updatedRow) return updatedRow;
  //       }
  //       return d;
  //     });

  //     const finalDetails = [...detailUpdatedRowData, ...detailNewRows];

  //     const changedMasters = [...masterUpdatedRows, ...masterNewRows];
  //     const changedDetails = [...detailUpdatedRows, ...detailNewRows];

  //     setRowData1(finalMasters);
  //     gridRef1.current?.api?.setRowData(finalMasters);

  //     setRowData2(finalDetails);
  //     setOriginalRowData2(JSON.parse(JSON.stringify(finalDetails)));
  //     setChangedRowData1(changedMasters);
  //     setChangedRowData2(changedDetails);
  //     if (mastersToDelete.length > 0) {
  //       setDeletedRowData1((prev) => {
  //         const existingDeleted = prev || [];
  //         const newDeleted = mastersToDelete.filter((rd) => !existingDeleted.some((ed) => ed.no === rd.no));
  //         return [...existingDeleted, ...newDeleted];
  //       });
  //     }
  //     if (detailsToDelete.length > 0) {
  //       setDeletedRowData2((prev) => {
  //         const existingDeleted = prev || [];
  //         const newDeleted = detailsToDelete.filter((rd) => !existingDeleted.some((ed) => ed.no === rd.no));
  //         return [...existingDeleted, ...newDeleted];
  //       });
  //     }

  //     dispatch(
  //       showSnackbar({
  //         message: '엑셀 업로드가 완료되었습니다.',
  //         type: 'success',
  //       })
  //     );
  //   } catch (error) {
  //     console.error('Excel upload error:', error);
  //     dispatch(
  //       showSnackbar({
  //         message: `엑셀 업로드 중 오류가 발생했습니다: ${error.message}`,
  //         type: 'error',
  //       })
  //     );
  //   } finally {
  //     dispatch(closeLoading());
  //   }
  // };

  // 엑셀 다운로드 (MST+DTL → PrintLogic1처럼 평면 15컬럼)
  // const ExcelDownload1 = async () => {
  //   try {
  //     dispatch(showLoading());

  //     const workbook = new ExcelJS.Workbook();
  //     const templateUrl = getTemplatePath();

  //     const response = await fetch(templateUrl);
  //     const arrayBuffer = await response.arrayBuffer();
  //     await workbook.xlsx.load(arrayBuffer);

  //     const worksheet = workbook.worksheets[0];
  //     if (!worksheet) {
  //       dispatch(
  //         showSnackbar({
  //           message: '템플릿 시트를 불러오지 못했습니다.',
  //           type: 'warning',
  //         })
  //       );
  //       dispatch(closeLoading());
  //       return;
  //     }

  //     const masters = (rowData1 || []).filter((r) => !r.deleteYn);
  //     const details = (rowData2 || []).filter((r) => !r.deleteYn);

  //     const flatRows = [];
  //     masters.forEach((master) => {
  //       const masterId = master.hbmId ?? master.no;
  //       const detailList = details.filter((d) => String(d.hbmId) === String(masterId));

  //       if (detailList.length === 0) {
  //         flatRows.push({
  //           processType: master.processType || '',
  //           workerName: master.workerName || '',
  //           productName: master.productName || '',
  //           substanceName: '',
  //           casNo: '',
  //           contentPercent: '',
  //           managementTarget: '',
  //           specialManagement: '',
  //           workEnvMeasurement: '',
  //           specialHealthExam: '',
  //           permissionTarget: '',
  //           firstExamMonths: master.firstExamMonths ?? '',
  //           examCycleMonths: master.examCycleMonths ?? '',
  //           distributionContact: master.distributionContact || '',
  //           remark: master.remark || '',
  //         });
  //       } else {
  //         detailList.forEach((detail) => {
  //           flatRows.push({
  //             processType: master.processType || '',
  //             workerName: master.workerName || '',
  //             productName: master.productName || '',
  //             substanceName: detail.substanceName || '',
  //             casNo: detail.casNo || '',
  //             contentPercent: detail.contentPercent ?? '',
  //             managementTarget: detail.managementTarget || 'N',
  //             specialManagement: detail.specialManagement || 'N',
  //             workEnvMeasurement: detail.workEnvMeasurement || 'N',
  //             specialHealthExam: detail.specialHealthExam || 'N',
  //             permissionTarget: detail.permissionTarget || 'N',
  //             firstExamMonths: master.firstExamMonths ?? '',
  //             examCycleMonths: master.examCycleMonths ?? '',
  //             distributionContact: master.distributionContact || '',
  //             remark: master.remark || '',
  //           });
  //         });
  //       }
  //     });

  //     const startRow = 7;
  //     const checkboxKeys = ['managementTarget', 'specialManagement', 'workEnvMeasurement', 'specialHealthExam', 'permissionTarget'];

  //     flatRows.forEach((item, index) => {
  //       const row = worksheet.getRow(startRow + index);
  //       EXCEL_COLUMN_KEYS.forEach((key, i) => {
  //         const cell = row.getCell(i + 1);
  //         let value = item[key];
  //         if (checkboxKeys.includes(key)) {
  //           value = value === 'Y' ? '✓' : '';
  //         } else {
  //           value = value !== null && value !== undefined ? String(value).trim() : '';
  //         }

  //         setPreserveStyle(cell, value);

  //         cell.font = { name: 'Arial', size: 10 };
  //         cell.alignment = {
  //           vertical: 'middle',
  //           horizontal: 'left',
  //           wrapText: false,
  //         };
  //         cell.border = {
  //           top: { style: 'thin', color: { argb: 'FF808080' } },
  //           left: { style: 'thin', color: { argb: 'FF808080' } },
  //           bottom: { style: 'thin', color: { argb: 'FF808080' } },
  //           right: { style: 'thin', color: { argb: 'FF808080' } },
  //         };
  //       });
  //       row.commit();
  //     });

  //     const maxDataRow = Math.max(startRow + flatRows.length, startRow + 200);
  //     const endRow = maxDataRow;

  //     // 체크박스 컬럼 드롭다운 (✓ 또는 빈값 - HEA_BASIC_02 noiseYn 방식)
  //     checkboxKeys.forEach((key) => {
  //       const colIndex = EXCEL_COLUMN_KEYS.indexOf(key);
  //       if (colIndex !== -1) {
  //         const colLetter = String.fromCharCode(65 + colIndex);
  //         worksheet.dataValidations.add(`${colLetter}${startRow}:${colLetter}${endRow}`, {
  //           type: 'list',
  //           allowBlank: true,
  //           formulae: ['"✓,"'],
  //           showErrorMessage: true,
  //           errorStyle: 'error',
  //           errorTitle: '입력 오류',
  //           error: '✓ 또는 빈값만 입력 가능합니다.',
  //         });
  //       }
  //     });

  //     const dateTimeStr = getCurrentFormattedDateTime('file');
  //     const methodName = `MSDS관리대장_${dateTimeStr}.xlsx`;

  //     const buffer = await workbook.xlsx.writeBuffer();
  //     const blob = new Blob([buffer], {
  //       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //     });
  //     const link = document.createElement('a');
  //     link.href = URL.createObjectURL(blob);
  //     link.download = methodName;
  //     link.click();

  //     dispatch(closeLoading());
  //   } catch (error) {
  //     console.error('Excel download error:', error);
  //     dispatch(
  //       showSnackbar({
  //         message: `엑셀 다운로드 중 오류가 발생했습니다: ${error.message}`,
  //         type: 'error',
  //       })
  //     );
  //     dispatch(closeLoading());
  //   }
  // };
  //#endregion

  function setPreserveStyle(cell, value) {
    if (!cell) return;
    const { font, alignment, border, fill, numFmt } = cell;
    cell.value = value;
    cell.style = { font, alignment, border, fill, numFmt };
  }

  function getTemplatePath() {
    const base = `${Global.file.useUrl}files/ExcellExportFrom/HazardousMaterials/`;
    return base + 'MSDS_관리대장.xlsx';
  }

  function getCurrentFormattedDateTime(_type) {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    if (_type === 'file') {
      return `${year}${month}${day}_${hours}${minutes}${seconds}`;
    }
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  //#endregion

  //#region 팝업 관련 함수
  // 물질명 팝업 열기 핸들러
  const handleSubstanceNamePopupOpen = (rowData) => {
    setSubstanceNamePopupRowData(rowData);
    // 기존 물질명이 있으면 태그로 변환
    if (rowData?.substanceName) {
      const tags = rowData.substanceName.split(',')
        .map((tag) => tag.trim())
        .filter((tag) => tag);
      setSubstanceNameTags(tags);
    } else {
      setSubstanceNameTags([]);
    }
    setSubstanceNamePopupOpen(true);
  };
  //#endregion

  //#region 인쇄 관련 함수
  const PrintLogic1 = async () => {
    dispatch(showLoading());
    try {
      // HeaderData에 오늘 날짜와 사용자 이름 추가
      const today = dayjs().format('YYYY-MM-DD');
      const headerData = {
        currentDate: today,
        userNm: userInfo?.userNm || '',
      };

      // TableData에 그리드 데이터 추가 (경고표지 이미지 포함)
      const tableData = await Promise.all(
        printGridData.map(async (item) => {
          let warningLabelImageBase64 = null;

          // 경고표지 이미지가 있는 경우 Base64로 변환
          const filePath = item.warningLabelFilePath;
          if (filePath) {
            try {
              // URL 인코딩 처리
              const fixedPath = fixUrl(filePath);
              const imageUrl = Global.file.useUrl + 'files/' + fixedPath;

              const base64Image = await ConvertImageToBase64(imageUrl);

              if (base64Image && base64Image.startsWith('data:')) {
                // Base64 문자열 추출
                const cleanBase64 = base64Image.replace(
                  /^data:image\/[a-z]+;base64,/,
                  ''
                );

                // 순수 Base64만 전달 (다른 파일들과 동일한 방식)
                // 레포트 서버가 Base64 시작 부분으로 이미지 형식을 자동 감지
                warningLabelImageBase64 = cleanBase64;
              } else {
                warningLabelImageBase64 = null;
              }
            } catch (error) {
              console.log(error);
              warningLabelImageBase64 = null;
            }
          }

          return {
            no: item.no || '',
            processType: item.processType || '',
            workerName: item.workerName || '',
            productName: item.productName || '',
            substanceName: item.substanceName || '',
            casNo: item.casNo || '',
            contentPercent: item.contentPercent || '',
            managementTarget: item.managementTarget || '',
            specialManagement: item.specialManagement || '',
            workEnvMeasurement: item.workEnvMeasurement || '',
            specialHealthExam: item.specialHealthExam || '',
            permissionTarget: item.permissionTarget || '',
            firstExamMonths: item.firstExamMonths || '',
            examCycleMonths: item.examCycleMonths || '',
            distributionContact: item.distributionContact || '',
            warningLabelFileName: item.warningLabelFileName || '',
            remark: item.remark || '',
            warningLabelImage: warningLabelImageBase64 || null,
          };
        })
      );

      const printData = {
        FileName: 'HAM_BASIC_03',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };
  //#endregion

  //#region 유틸리티 함수
  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  // URL 인코딩 처리
  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  // 파일 확장자 추출 헬퍼
  const getExtension = (url) => {
    if (!url) return '';
    const name = url.split('/').pop();
    return name?.split('.').pop().toLowerCase() || '';
  };

  // 이미지를 Base64로 변환하는 함수
  const ConvertImageToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        return '';
      }
      const blob = await response.blob();

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result); // Base64 문자열 반환
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob); // Blob을 Base64로 변환
      });
    } catch (error) {
      console.log(error);
      return '';
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <HAM_BASIC_02
        gridId1={'grid1'}
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        gridRef1={gridRef1}
        gridRef2={gridRef2}
        rowData1={rowData1}
        setRowData1={setRowData1}
        rowData2={rowData2}
        setRowData2={setRowData2}
        originalRowData2={originalRowData2}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        deletedRowData1={deletedRowData1}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        // Detail 그리드 props
        selectedRowData2={selectedRowData2}
        setSelectedRowData2={setSelectedRowData2}
        changedRowData2={changedRowData2}
        setChangedRowData2={setChangedRowData2}
        deletedRowData2={deletedRowData2}
        setDeletedRowData2={setDeletedRowData2}
        DeleteNewRow2={deleteHandler2.DeleteNewRow}
        RestoreRow2={deleteHandler2.RestoreRow}
        MarkedForDeletion2={deleteHandler2.MarkedForDeletion}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 함수
        validateSelection={validateSelection}
        ResetLogic1={ResetLogic1}
        SearchLogic1={SearchLogic1}
        SaveLogic1={SaveLogic1}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection1={handleRowSelection1}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={MarkedForDeletion1}
        DeleteNewRow1={DeleteNewRow1}
        fileModalToggle={fileModalToggle}
        setFileModalToggle={setFileModalToggle}
        previewFileName={previewFileName}
        setPreviewFileName={setPreviewFileName}
        previewUrl={previewUrl}
        setPreviewUrl={setPreviewUrl}
        fileUploadInputRef={fileUploadInputRef}
        PopupClickEvent1={PopupClickEvent1}
        handleFileClick={handleFileClick}
        handleFileChange={handleFileChange}
        handleFileDelete={handleFileDelete}
        renderPreview={renderPreview}
        DownloadLogic1={DownloadLogic1}
        fileInputRef={fileInputRef}
        // ExcelUpload1={ExcelUpload1}
        // ExcelDownload1={ExcelDownload1}
        handleFileModalSave={handleFileModalSave}
        PrintLogic1={PrintLogic1}
        substanceNamePopupOpen={substanceNamePopupOpen}
        setSubstanceNamePopupOpen={setSubstanceNamePopupOpen}
        substanceNamePopupRowData={substanceNamePopupRowData}
        setSubstanceNamePopupRowData={setSubstanceNamePopupRowData}
        substanceNameTags={substanceNameTags}
        setSubstanceNameTags={setSubstanceNameTags}
        handleSubstanceNamePopupOpen={handleSubstanceNamePopupOpen}
        handleAddSubItem={handleAddSubItem}
        SaveLogicPreview={SaveLogicPreview}
      />
    </div>
  );
}

export default HAM_BASIC_02F;
